import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../_config/v2/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export class Service {
	async getPharmacy() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/country/${Enviroment.COUNTRY}/pharmacy/${Enviroment.ROOT_PHARMACY}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
